module.exports = __webpack_public_path__ + "static/media/ambassador.e78425c3.svg";